const actionTypes = {
  LOAD_GRAVESTONES: 'LOAD_GRAVESTONES',
  SELECT_GRAVESTONE: 'SELECT_GRAVESTONE',
  CHANGE_CENTER_AND_ZOOM: 'CHANGE_CENTER_AND_ZOOM',
  CHANGE_BOUNDS: 'CHANGE_BOUNDS',
  TOGGLE_ABOUT: 'TOGGLE_ABOUT',
  TOGGLE_CONTACT_US: 'TOGGLE_CONTACT_US',
  LOCATED_USER: 'LOCATED_USER',
  ZOOM_TO_HEADSTONE: 'ZOOM_TO_HEADSTONE',
  TOGGLE_HILLSHADE: 'TOGGLE_HILLSHADE',
};

export default actionTypes;



// WEBPACK FOOTER //
// ./src/store/actionTypes.js